export const SOURCES = {
  porto_teg: 'porto_teg',
};
